import React, { Component } from 'react';
import { withRouter } from '../WithRouterHOC';
import { Modal, Select, Input, message, Checkbox } from 'antd';
import { _new_nim_window, _new_room_window } from '../../store/Action';
import HTTP from '../../script/service';
import Util from '../../script/util';
import WEBIM from '../../store/WebNim';
import './index.scss';

class index extends Component {
  constructor(proos) {
    super(proos);
    this.state = {
      selClass: {},
      ps: '',
      selCat: {},
      allTypes: [],
      param: {
        ifRecommend: 1,
      },
      roomConfig: null,
      sendUserUid: null, // 发送消息的uid
    };
  }

  /**
   * 打开创建开黑房
   * @param roomConfig 房间信息
   * @param sendUserUid uid 2.4.4.1需求 -> todo 创建成功给用户发送飞机票
   */
  showModal = (roomConfig, sendUserUid = null) => {
    HTTP._get_black_team_category_list().then((res) => {
      if (res?.code === 200) {
        this.setState(
          {
            roomConfig: roomConfig || null,
            allTypes: res.data,
            saveLoading: false,
            sendUserUid,
          },
          () => {
            const { uid } = this.props.base;
            HTTP._get_my_game_rooms({
              uid: uid,
            }).then((res) => {
              if (res.code == 200) {
                this.initForm(res.data);
              } else {
                this.setState({
                  selClass: {},
                  selCat: {},
                  param: {
                    ifRecommend: 1,
                  },
                  ps: '',
                  visible: true,
                });
              }
            });
          }
        );
      }
    });
  };
  initForm = (data) => {
    const { allTypes } = this.state;
    //游戏大类
    let selClass = allTypes.filter((item) => item.typeId == data.extInfo.ctype);
    selClass = selClass.length > 0 ? selClass[0] : {};
    //游戏小类
    let selCat = {};
    if (selClass.blackTeamCategorys) {
      selCat = selClass.blackTeamCategorys.filter(
        (item) => item.categoryId == data.blackTeamRoomInfo.categoryId
      );
      selCat = selCat.length > 0 ? selCat[0] : {};
    }
    this.setState({
      selClass: { ...selClass },
      selCat: { ...selCat },
      ps: data.blackTeamRoomInfo.password,
      param: {
        ...data.blackTeamRoomInfo,
        name: data.name,
        roomid: data.roomid,
      },
      visible: true,
    });
  };
  hideModal = () => {
    this.setState({
      visible: false,
      saveLoading: false,
    });
  };
  //选择游戏分类
  onChangeClass = (e) => {
    const { allTypes, param } = this.state;
    let items = allTypes.filter((item) => item.typeId == e);
    param.categoryId = null;
    param.svr = null;
    param.mode = null;
    param.level = null;
    param.people = null;
    this.setState({
      selClass: items.length > 0 ? items[0] : {},
      param: { ...param },
      selCat: {},
    });
  };
  //选择游戏
  onChangeCat = (e) => {
    const { selClass, param } = this.state;
    if (!selClass.blackTeamCategorys) {
      param.categoryId = null;
      param.svr = null;
      param.mode = null;
      param.level = null;
      param.people = null;
      this.setState({
        selCat: {},
        param: { ...param },
      });
      return;
    }
    let items = selClass.blackTeamCategorys.filter(
      (item) => item.categoryId == e
    );
    if (items.length > 0) {
      param.categoryId = e;
      param.svr = null;
      param.mode = null;
      param.level = null;
      param.people = null;
      this.setState({
        selCat: items[0],
        param: { ...param },
      });
    } else {
      param.categoryId = null;
      param.svr = null;
      param.mode = null;
      param.level = null;
      param.people = null;
      this.setState({
        selCat: {},
        param: { ...param },
      });
    }
  };
  //选择区服
  onChangeSvrs = (e) => {
    const { param } = this.state;
    param.svr = e || null;
    this.setState({
      param: { ...param },
    });
  };
  //选择模式
  onChangeModes = (e) => {
    const { param } = this.state;
    param.mode = e || null;
    this.setState({
      param: { ...param },
    });
  };
  //选择段位
  onChangeLevels = (e) => {
    const { param } = this.state;
    param.level = e || null;
    this.setState({
      param: { ...param },
    });
  };
  //选择人数
  onChangePeoples = (e) => {
    const { param } = this.state;
    param.people = e || null;
    this.setState({
      param: { ...param },
    });
  };
  //房间名称
  changeRoomName = (e) => {
    const { param } = this.state;
    param.name = e.target.value;
    this.setState({
      param: { ...param },
    });
  };
  onChangeReCommend = (e) => {
    const { param } = this.state;
    param.ifRecommend = e.target.checked;
    this.setState({
      param: { ...param },
    });
  };
  submitCatForm = () => {
    const { param, ps, roomConfig, sendUserUid } = this.state;
    const { uid } = this.props.base;
    param.uid = uid;
    if (!param.categoryId) {
      message.warning('请选择游戏');
      return;
    }
    if (!param.name) {
      message.warning('请输入房间名称');
      return;
    }
    param.password = ps;
    if (
      !param.password ||
      param.password.length !== 4 ||
      isNaN(param.password)
    ) {
      message.warning('请正确输入房间密码：4位数字或字符');
      return;
    }
    param.ifRecommend = param.ifRecommend ? 1 : 0;
    this.setState({
      saveLoading: true,
    });

    HTTP._create_my_game_rooms(param).then((res) => {
      if (res.code == 200) {
        if (roomConfig) {
          this.setState({ saveLoading: false });
        } else {
          if (sendUserUid) {
            this.followP2PChart(sendUserUid, res.data.roomid);
          } else {
            _new_room_window(
              {
                roomid: res.data.roomid,
                roomname: res.data.name,
              },
              this.props.history
            );
          }
        }

        this.setState({ visible: false });
      } else {
        this.setState({
          saveLoading: false,
        });
        message.error(res.message);
      }
    });
  };
  // 打开聊天框
  followP2PChart = (uid, roomid) => {
    const account = Util.$analyToAccount(uid);
    const text = `${window.location.origin}/room?roomid=${roomid}`;
    WEBIM.sendText(text, null, account);
    let to = {
      id: `p2p-${account}`,
      scene: 'p2p',
      account: account,
    };
    _new_nim_window(to);
    this.hideModal();
  };
  render() {
    const {
      visible,
      param,
      allTypes,
      selClass,
      selCat,
      ps,
      saveLoading,
      roomConfig,
    } = this.state;
    let svrs = null; // 区服
    let levels = null; //段位
    let modes = null; //模式
    let peoples = null; //人数
    if (selCat && selCat.svrs) {
      svrs = selCat.svrs.split(',');
    }
    if (selCat && selCat.level) {
      levels = selCat.level.split(',');
    }
    if (selCat && selCat.modes) {
      modes = selCat.modes.split(',');
    }
    if (selCat && selCat.people) {
      peoples = selCat.people.split(',');
    }
    return (
      <Modal
        open={visible}
        wrapClassName="daidai-modal-style has-top-border"
        centered={true}
        title={roomConfig ? '房间设置' : '创建房间'}
        footer={null}
        keyboard={false}
        maskClosable={false}
        width="500px"
        zIndex="1005"
        onCancel={this.hideModal}
      >
        <div className="game-create-form">
          <div className="form-row">
            <div className="form-label">选择游戏：</div>
            <div className="form-control">
              <Select
                style={{ width: 170 }}
                value={selClass.typeId || undefined}
                placeholder="请选择"
                onChange={this.onChangeClass}
              >
                {allTypes.map((item, index) => (
                  <Select.Option key={index} value={item.typeId}>
                    {item.typeName}
                  </Select.Option>
                ))}
              </Select>
              <Select
                style={{ width: 170, marginLeft: 10 }}
                value={param.categoryId || undefined}
                placeholder="请选择"
                onChange={this.onChangeCat}
              >
                {selClass.blackTeamCategorys &&
                  selClass.blackTeamCategorys.map((item, index) => (
                    <Select.Option key={index} value={item.categoryId}>
                      {item.name}
                    </Select.Option>
                  ))}
              </Select>
            </div>
          </div>
          {svrs ? (
            <div className="form-row">
              <div className="form-label">选择区服：</div>
              <div className="form-control">
                <Select
                  style={{ width: 350 }}
                  value={param.svr || ''}
                  placeholder="请选择"
                  onChange={this.onChangeSvrs}
                >
                  <Select.Option value="">不限</Select.Option>
                  {svrs.map((item, index) => (
                    <Select.Option key={index} value={item}>
                      {item}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </div>
          ) : null}
          {modes ? (
            <div className="form-row">
              <div className="form-label">选择模式：</div>
              <div className="form-control">
                <Select
                  style={{ width: 350 }}
                  value={param.mode || ''}
                  placeholder="请选择"
                  onChange={this.onChangeModes}
                >
                  <Select.Option value="">不限</Select.Option>
                  {modes.map((item, index) => (
                    <Select.Option key={index} value={item}>
                      {item}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </div>
          ) : null}
          {levels ? (
            <div className="form-row">
              <div className="form-label">选择段位：</div>
              <div className="form-control">
                <Select
                  style={{ width: 350 }}
                  value={param.level || ''}
                  placeholder="请选择"
                  onChange={this.onChangeLevels}
                >
                  <Select.Option value="">不限</Select.Option>
                  {levels.map((item, index) => (
                    <Select.Option key={index} value={item}>
                      {item}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </div>
          ) : null}
          {peoples ? (
            <div className="form-row">
              <div className="form-label">选择人数：</div>
              <div className="form-control">
                <Select
                  style={{ width: 350 }}
                  value={param.people || ''}
                  placeholder="请选择"
                  onChange={this.onChangePeoples}
                >
                  <Select.Option value="">不限</Select.Option>
                  {peoples.map((item, index) => (
                    <Select.Option key={index} value={item}>
                      {item}
                    </Select.Option>
                  ))}
                </Select>
              </div>
            </div>
          ) : null}
          <div className="form-row">
            <div className="form-label">房间名称：</div>
            <div className="form-control">
              <Input
                placeholder="请填写房间名称"
                maxLength={12}
                style={{ width: 350 }}
                value={param.name || ''}
                onChange={this.changeRoomName}
                autoComplete="off"
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-label">密码：</div>
            <div className="form-control">
              <Input.OTP
                value={ps}
                length={4}
                formatter={(val) => val.replace(/\D/g, '')}
                onInput={(val) => this.setState({ ps: val.join('') })}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-label">&nbsp;</div>
            <div className="form-control">
              <Checkbox
                checked={param.ifRecommend}
                className="mebox"
                onChange={this.onChangeReCommend}
              >
                我要上推荐，让更多人看到房间
              </Checkbox>
              <p className="checkbox-remark">
                如果不勾选，房间将不会出现在热门推荐中哦
              </p>
            </div>
          </div>
          <div className="form-row">
            <span className="btnss">
              {saveLoading ? (
                <button className="daidai-btn-primary disable">正在创建</button>
              ) : (
                <button
                  className="daidai-btn-primary"
                  onClick={this.submitCatForm}
                >
                  {roomConfig ? '保存设置' : '创建房间'}
                </button>
              )}
            </span>
          </div>
        </div>
      </Modal>
    );
  }
}

export default withRouter(index, { withRef: true });
